import React from 'react';
import logo from '../assets/Acadian Logo Colored - Stacked.png';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { FaComputer } from 'react-icons/fa6';
import squareLogo from '../assets/squareLogoWhite.png';

const RyanContact = () => {
  return (
    <div className='w-screen h-screen flex flex-col items-center justify-center bg-blue-900 text-white gap-6'>
      <div className='flex items-center justify-center w-[250px] h-[250px] overflow-hidden bg-white rounded-full'>
        <img src={logo} alt='Ryan Avatar' className='w-[60%]' />
      </div>
      <h4 className='text-5xl'>Ryan Leger</h4>
      <h5 className='text-2xl -mt-2'>President</h5>
      <a href='tel: +1-337-962-4476' className=''>
        <button className='flex items-center justify-center gap-2 px-6 py-4 bg-green-600 rounded-3xl'>
          <FaPhoneAlt className='text-lg' />
          CALL ME
        </button>
      </a>
      <a href='mailto: ryan@acadianpos.com' className=''>
        <button className='flex items-center justify-center gap-2 px-6 py-4 bg-red rounded-3xl'>
          <FaEnvelope className='text-lg' />
          EMAIL ME
        </button>
      </a>
      <a href='/' target='_blank'>
        <button className='flex items-center justify-center gap-2 px-6 py-4 bg-orange-500 rounded-3xl'>
          <FaComputer className='text-lg' />
          OUR WEBSITE
        </button>
      </a>
      <a href='https://squareup.com/i/F1E3093FE0' target='_blank'>
        <button className='flex items-center justify-center gap-2 px-6 py-4 bg-purple-600 rounded-3xl'>
          Sign up for
          <img src={squareLogo} alt='Square POS Logo' className='w-[80px]' />
        </button>
      </a>
    </div>
  );
};

export default RyanContact;
